module.exports = __webpack_public_path__ + "img/icon-wallet-2.be981499.svg";